import { paginationSize } from '../../constants/constants';
import { FETCH_MIP_RADIOLOGIST_USERS_ERROR, FETCH_MIP_RADIOLOGIST_USERS_SUCCESS, FETCH_WORKLIST_VISITS_ERROR, FETCH_WORKLIST_VISITS_START, FETCH_WORKLIST_VISITS_SUCCESS, HIDE_WORKLIST_VISIT_MODAL, RESET_WORKLIST_VISITS_FILTER, SET_ASSIGN_RADIOLOGIST_MODAL_CONFIG, SET_WORKLIST_FILTER, SET_WORKLIST_PAGINATION, SHOW_WORKLIST_VISIT_MODAL, UPDATE_WORKLIST_VISIT_RADIOLOGIST_ERROR, UPDATE_WORKLIST_VISIT_RADIOLOGIST_START, UPDATE_WORKLIST_VISIT_RADIOLOGIST_SUCCESS, UPDATE_WORKLIST_VISIT_STUDY_ERROR, UPDATE_WORKLIST_VISIT_STUDY_START, UPDATE_WORKLIST_VISIT_STUDY_SUCCESS } from '../actions/worklistVisitsActions';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    worklist: [],
    searchFilter: {
        searchText: "",
        mipIds: [],
        modalityIds: [],
        radiologist: [],
        state: [],
        startDate: null,
        endDate: null
    },
    sortConditions: [{ sortBy: "priority", dataType: "STRING", sortType: "asc" }],
    mipRadiologistUsers: [],
    modalConfig: {
        visible: false,
        title: null,
        summary: null,
    },
    showModal: false,
    selectedWorklistVisit: null,
    selectedWorklistVisitLoading: false

};

const worklistVisitsReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    switch (action.type) {
        case FETCH_WORKLIST_VISITS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_WORKLIST_VISITS_SUCCESS: {

            return { ...state, error: '', message: '', loading: false, worklist: action.worklist };
        }
        case FETCH_WORKLIST_VISITS_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }

        case FETCH_MIP_RADIOLOGIST_USERS_SUCCESS: {
            return { ...state, loading: false, mipRadiologistUsers: [...action.mipRadiologistUsers], message: '' };
        }

        case FETCH_MIP_RADIOLOGIST_USERS_ERROR: {
            return { ...state, loading: false, mipRadiologistUsers: [], message: '' };
        }
        case UPDATE_WORKLIST_VISIT_RADIOLOGIST_START: {
            return { ...state, submitting: true };
        }
        case UPDATE_WORKLIST_VISIT_RADIOLOGIST_SUCCESS: {
            return {
                ...state,
                submitting: false,
                modalConfig: {
                    ...state.modalConfig,
                    visible: false,
                    title: null,
                    summary: null,
                }
            };
        }
        case UPDATE_WORKLIST_VISIT_RADIOLOGIST_ERROR: {
            return { ...state, error: action.error, submitting: false }
        }
        case SET_ASSIGN_RADIOLOGIST_MODAL_CONFIG: {
            return { ...state, modalConfig: { ...state.modalConfig, ...action.config, summary: null } };
        }
        case SET_WORKLIST_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case SET_WORKLIST_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            return {
                ...newState
            }
        }

        case UPDATE_WORKLIST_VISIT_STUDY_START: {
            return { ...state, error: '', message: '', selectedWorklistVisitLoading: true }
        }
        case SHOW_WORKLIST_VISIT_MODAL: {
            return { ...state, showModal: true, selectedWorklistVisit: action.selectedVisit };
        }
        case UPDATE_WORKLIST_VISIT_STUDY_ERROR:
        case HIDE_WORKLIST_VISIT_MODAL: {
            return { ...state, error: '', message: '', selectedWorklistVisitLoading: false, showModal: false }
        }
        case UPDATE_WORKLIST_VISIT_STUDY_SUCCESS: {
            let newState = { ...state };
            let index = state.worklist.findIndex(worklistItem => worklistItem.reportId === action.visit.reportId)

            if (index > -1) {
                let modifiedVisit = newState.worklist[index];
                modifiedVisit.priority = action.visit.priority;
                newState.worklist[index] = { ...modifiedVisit };
            }

            return { ...newState, error: '', message: '', selectedWorklistVisitLoading: false, showModal: false }
        }
        case RESET_WORKLIST_VISITS_FILTER: {
            newState = { ...state };
            newState.searchFilter.searchText = null;
            newState.searchFilter.radiologist = [];
            newState.searchFilter.state = [];
            return { ...newState };
        }

        default:
            return state;
    }
}

export default worklistVisitsReducer;
